@let isDrawingMenuOpened = isDrawingMenuOpened$ | async;
    <div class="toolbar-button-container">
        <pcp-slide-sync-toolbar-button
                class="toolbar-button"
                [matIcon]="icon"
                [fontSet]="fontSet"
                (toggle)="toggleDrawingMenu()"
                [turnedOn]="isDrawingMenuOpened === true"
                [disabled]="(isDrawingEnabled$ | async) === false"
        ></pcp-slide-sync-toolbar-button>

        <!-- hidden by default but it's shown on click -->
        <pcp-drawing-menu
            class="toolbar-menu-overlay"
            [ngClass]="{ hidden: !isDrawingMenuOpened }"
        ></pcp-drawing-menu>
    </div>
